import { VStack } from '@chakra-ui/react'
import React from 'react'
import { BadgeFormFilingMethod, BadgeQueueNotifyStatus, BadgeQueueStatus, LabelInfo, SectionForm, TextDateFormat } from '../shared'
import TableUserQueue from './TableUserQueue'

const QueueInfo = ({ data }) => {
    // console.log(data)
    return (
        <VStack w="full">
            <SectionForm header="ข้อมูลผู้ยื่น">
                <LabelInfo title="ชื่อ-นามสกุล">{`${data.first_name} ${data.last_name}`}</LabelInfo>
                <LabelInfo title="ตำแหน่ง">{data.position_name}</LabelInfo>
                <LabelInfo title="หน่วยงาน">{data.office_name}</LabelInfo>
                <LabelInfo title="โทร">{data.tel}</LabelInfo>
                <LabelInfo title="อีเมล">{data.email}</LabelInfo>
                <LabelInfo title="ที่อยู่">{data.address}</LabelInfo>
            </SectionForm>
            <SectionForm header="ข้อมูลอาคารที่ขอเข้าพัก">
                <LabelInfo title="อาคาร">{data.residence_name}</LabelInfo>
                <LabelInfo title="ลำดับ">{data.order}</LabelInfo>
                <LabelInfo title="วันที่ยื่น">{`${data.submit_date} เวลา ${data.submit_time} น.`}</LabelInfo>
                <LabelInfo title="วิธีที่ยื่น"><BadgeFormFilingMethod online={data.online} /></LabelInfo>
                <LabelInfo title="สถานะคิว"><BadgeQueueStatus status={data.queue_status_id} /></LabelInfo>
                <LabelInfo title="วันที่อัพเดทข้อมูลล่าสุด"><TextDateFormat value={data.updated_at} full/></LabelInfo>
            </SectionForm>
            <SectionForm header="ข้อมูลลำดับคิวอื่นๆ ของผู้ยื่น" divider={!!data.notify_date}>
                <TableUserQueue targetName={`${data.first_name} ${data.last_name}`} filterQueueID={data.id}/>
            </SectionForm>
            <SectionForm header="การแจ้งวันนัดทำสัญญา" divider={false} collapse={!data.notify_date}>
                <LabelInfo title="สถานะการแจ้งวันนัด"><BadgeQueueNotifyStatus value={data.notify_date} /></LabelInfo>
                <LabelInfo title="วันที่แจ้ง"><TextDateFormat value={data.notify_date} full /></LabelInfo>
                <LabelInfo title="แจ้งไปที่อีเมล">{data.notify_to_email}</LabelInfo>
                <LabelInfo title="วัน/เวลานัด">{data.appointment_date}</LabelInfo>
                <LabelInfo title="สถานะที่นัด">{data.appointment_location}</LabelInfo>
                <LabelInfo title="ผู้แจ้ง">{data.notify_user_name}</LabelInfo>
            </SectionForm>
        </VStack>
    )
}

export default QueueInfo
